import React, { useEffect } from 'react';

export const useOutsideClick = (ref: React.MutableRefObject<HTMLDivElement | null>, outsideClick: () => void): void => {
  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        outsideClick();
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [outsideClick, ref]);
};
